import React from 'react'

const Footer = () => {
    return (
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        <script>document.write(new Date().getFullYear())</script> © 2024 Aardvark Safaris Lodges Reservations.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-sm-end d-none d-sm-block">
                            {/* With SUpport from Population Services International */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer